import { useQuery } from '@tanstack/react-query';
import { queryKeyFactory } from 'utils/query-client';
import { loaders } from './transmission-acts.loaders';
import {
  DepositsFilters,
  TransactionsFilters,
  TransmissionActsFilters,
} from './transmission-acts.types';
import { converters } from './transmission-acts.converters';

export const transmissionActsKeys = queryKeyFactory('transmission-acts');

export const useTransmissionActs = (
  filters: Partial<TransmissionActsFilters> = {},
  options: { enabled?: boolean } = {},
) => {
  return useQuery({
    queryKey: transmissionActsKeys.list(filters),
    queryFn: () => loaders.getTransmissionActs({ filters }),
    select: converters.getTransmissionActs,
    enabled: options.enabled,
  });
};

export const useTransmissionAct = (transmissionActId: string) => {
  return useQuery({
    queryKey: transmissionActsKeys.detail(transmissionActId),
    queryFn: () => loaders.getTransmissionAct({ transmissionActId }),
    select: converters.getTransmissionAct,
    enabled: !!transmissionActId,
  });
};

export const useTransactions = (
  filters: Partial<TransactionsFilters> = {},
  options: { enabled?: boolean } = {},
) => {
  return useQuery({
    queryKey: transmissionActsKeys.list('transactions', filters),
    queryFn: () => loaders.getTransactions({ filters }),
    select: converters.getTransactions,
    enabled: options.enabled,
  });
};

export const useDeposits = (
  filters: Partial<DepositsFilters> = {},
  options: { enabled?: boolean } = {},
) => {
  return useQuery({
    queryKey: transmissionActsKeys.list('deposits', filters),
    queryFn: () => loaders.getDeposits({ filters }),
    select: converters.getDeposits,
    enabled: options.enabled,
  });
};
